export default __webpack_public_path__ + "population-500-bd3c270197516dfb132a78b4eab5c505.png";